import { render, staticRenderFns } from "./TraditionalSimplifiedShow.vue?vue&type=template&id=1f437646&"
import script from "./TraditionalSimplifiedShow.vue?vue&type=script&lang=js&"
export * from "./TraditionalSimplifiedShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports